import { render, staticRenderFns } from "./business-current.vue?vue&type=template&id=5735bbe8&scoped=true&"
import script from "./business-current.vue?vue&type=script&lang=js&"
export * from "./business-current.vue?vue&type=script&lang=js&"
import style0 from "./business-current.vue?vue&type=style&index=0&id=5735bbe8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5735bbe8",
  null
  
)

export default component.exports